
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function RecruitBanner() {
  const bannerAnim = useScrollAnimation({ rootMargin: '0px 0px -80px 0px' });

  const fallbackSrc =
    "https://via.placeholder.com/1200x600?text=Image+not+available";

  const handleImgError = (
    e: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    const target = e.currentTarget;
    if (target.src !== fallbackSrc) {
      target.src = fallbackSrc;
    }
  };

  return (
    <section className="py-8 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={bannerAnim.ref}
          className={bannerAnim.isVisible ? 'anim-scale-in' : 'anim-hidden'}
        >
          <div className="relative w-full aspect-[4/3] sm:aspect-[16/9] md:aspect-[21/9] rounded-xl md:rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/4b5ab8a1d4f57863f0ac392ceacb05cd.png"
              alt="宝珠運輸のトラック"
              className="w-full h-full object-cover object-center"
              onError={handleImgError}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/20 sm:from-black/60 sm:to-black/30 flex items-end sm:items-center">
              <div className="max-w-2xl px-6 pb-6 sm:px-8 md:px-12 sm:pb-0">
                <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white mb-3 md:mb-4">
                  今できることを、大切に。
                </h2>
                <p className="text-sm sm:text-base md:text-lg text-white/90 mb-4 md:mb-6">
                  安全・丁寧・確実な業務で、地域の暮らしを支えています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
